<template>
  <div>
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div>

        </div>
        <div class="card card-competencias">
          <div class="card-header">
            <h4 class="card-title">Minhas Competências <loading-spin :check="loading"> </loading-spin></h4>
            <p class="category">Em quais competências serei avaliado?</p>
          </div>
          <div class="card-content">
            <el-collapse>
              <el-collapse-item v-for="(skill, index) in skills" :title="skill.name" :key="keyVfor(index)" >
                <div style="padding-left: 15px;">
                  {{ skill.description }}<br/><br/>
                </div>                
              </el-collapse-item>
            </el-collapse>
            <div style="padding-bottom: 15px;" v-if="(skills.length === 0)">
              <p class="category">
                Competências não foram encontradas! Por favor, entre em contato com a equipe de suporte <router-link to="/suporte" tag="b">
                  <a>aqui</a>
                </router-link>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Collapse, CollapseItem} from 'element-ui'
  import VueTabs from 'vue-nav-tabs'

  Vue.use(VueTabs)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  export default {
    mounted () {
      this.getMySkills()
    },
    data () {
      return {
        skills: [],
        activeName: 'first',
        loading: false
      }
    },
    methods: {
      async getMySkills () {
        let url = '/collaborator/my-skills'
        this.loading = true
        await axios.get(url)
        .then((response) => {
          this.skills = response.data
        }).catch((error) => {
          console.log(error)
        })
        this.loading = false
      },
      keyVfor (index) {
        return index + Math.random().toString(5).slice(2)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/CompetenciasCard.vue